<template>
  <div class="plan-box plan-premium">
      <h3 style="margin-bottom: 1rem">{{ $gettext('Upgrade to Premium') }}</h3>
      
      <div class="plan-box-content-wrap">

        <div class="plan-box-content__left">
          <slot name="planprice" />
          <slot name="teamsize" />
          <slot name="billingcycle" />
        </div>

        <div class="plan-box-content__right">
          <div class="content-wrap">

            <div class="price-wrap">
              <div class="main-price" v-html="beautifiedAmount" />
              <div class="price-breakdown">
                <span>{{ $gettext('VAT applies') }}</span>
                <div v-if="priceData.yearlyCycle" class="breakdown-discount ml-2">
                  <span class="savings">{{ $gettext('You save') + ' €' + totalDiscount }}</span>
                </div>
              </div>
            </div>

            <GekkoButton
              @click="$emit('create-plan', false)"
              :text="$gettext('Upgrade to premium')"
              size="lg"
              class="px-4"
            />
          </div>

        </div>
      </div>
        
  </div>
</template>

<script>
import GekkoButton from '@/components/GekkoButton.vue'
export default {
  name: 'PlanBoxPremium',
  components: {
    GekkoButton,
  },
  props: {
    priceData: {
      type: Object,
      default: () => {}
    },
    triggerAmount: {
      type: String,
      default: null
    },
    totalDiscount: {
      type: [Number, String],
      default: null
    },
  },
  data () {
    return {
    }
  },
  computed: {
    beautifiedAmount () {
      const amount = this.priceData.finalPrice.toFixed(2)
      const decimal_part = amount.split('.')[1]
      return '€' + Math.floor(amount) + '<span class="price-fraction">.'+ decimal_part +'</span>'
    }
  },
}
</script>

<style lang="scss" scoped>
  .plan-box-content-wrap {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    h4 { margin-bottom: 0.5rem; }
    .plan-box-content__left {
      display: flex; 
      flex-direction: column; 
      width: 100%; 
      gap: 1rem;

      .billingcycle-date {
        text-align: center;
        display: block;
        font-size: 14px;
        color: $colorUnassigned;
        margin-bottom: 0.5rem;
      }
    }
    .plan-box-content__right {
      display: flex; 
      flex: 1; 
      padding-top: 2rem;
      margin-top: 2rem;
      border-top: 1px solid #f2f2f2;
      justify-content: center;
      align-items: center;
      .price-breakdown { height: 48px; }
      .content-wrap {
        display: flex; 
        flex-direction: column; 
        flex: 1; 
        max-width: 360px;
        height: 100%;
      }
    }
    @media (min-width: '992px') {
      .plan-box-content__left {
        width: 450px;
      }
      .plan-box-content__right {
        width: 450px;
      }
    }
  }
</style>

